// import React, { useEffect, useState } from 'react';
import React, { useState } from 'react';

import dynamic from 'next/dynamic';
import * as Styled from './styles';
// import Link from 'next/link';
import { imageUrls } from '../../utils/constants';
import Image from 'next/image';
import {
  copyToClipboardText,
  /* Commented to handle withdrawl flow */
  // getConversionRatesVariables,
  toCustomFixed,
} from '../../utils/helpers';
import { useApp } from '../../../context/AppContext';
import Tab from 'react-bootstrap/Tab';
import Accordion from 'react-bootstrap/Accordion';

import { toast } from 'react-toastify';
/* Commented to handle withdrawl flow */
// import router from 'next/router';
import PROFILE_URLS from '../../utils/constants/images/profile';

import clsx from 'clsx';
import { useDeviceDetect } from '../../hooks/useDeviceDetect';
// import { useTokenConvertionRates } from '../../hooks/query';
import HOMEPAGE from '../../utils/constants/images/homepage';

const TansactionsList = dynamic(() => import('./components/transactionsList'));

const SendTransaction = dynamic(() => import('./components/sendTransaction'));

const WalletDetails = () => {
  const [key, setKey] = useState('sendTransaction');
  // const [algoPriceInUSD, setAlgoPrice] = useState(0);
  // const [zonePriceInUSD, setZonePrice] = useState(0);
  // const [USDCPriceInUSD, setUSDCPrice] = useState(0);
  // const [BNBPriceInUSD, setBNBPrice] = useState(0);
  // const [PEPEPriceInUSD, setPEPEPrice] = useState(0);
  // const [DeflyPriceInUSD, setDeflyPrice] = useState(0);
  // const [STKEPriceInUSD, setSTKEPrice] = useState(0);
  // const [GAlgoPriceInUSD, setGAlgoPrice] = useState(0);
  // const [CoopPriceInUSD, setCoopPrice] = useState(0);

  const algoPriceInUSD = 0;
  const zonePriceInUSD = 0;
  const USDCPriceInUSD = 0;
  const BNBPriceInUSD = 0;
  const PEPEPriceInUSD = 0;
  const DeflyPriceInUSD = 0;
  const STKEPriceInUSD = 0;
  const GAlgoPriceInUSD = 0;
  const CoopPriceInUSD = 0;

  const [tab, setTab] = useState(1);
  // const { getTokenConversionRates, tokenConvertionRates } =
  //   useTokenConvertionRates();
  /* added to handle build issue for withdrawl flow changes */
  // console.log('getTokenConversionRates', getTokenConversionRates);
  const {
    state: {
      wallet: {
        balanceAlgo,
        balanceZone,
        USDCBalance,
        pepeBalance,
        account,
        balanceBNB,
        blockChain,
        gAlgoBalance,
        algoStkBalance,
        deflyBalance,
        CoopBalance,
        MetaBalance,
      },
    },
  } = useApp();
  console.log('');
  const total =
    blockChain === 'BINANCE'
      ? balanceBNB
      : balanceAlgo +
        balanceZone +
        USDCBalance +
        pepeBalance +
        gAlgoBalance +
        algoStkBalance +
        deflyBalance +
        CoopBalance +
        MetaBalance;

  /* Commented to handle withdrawl flow */
  // useEffect(() => {
  //   const token = localStorage.getItem('token');
  //   if (account) {
  //     getTokenConversionRates(getConversionRatesVariables('USD', blockChain));
  //   } else if (!token) {
  //     router.push('/');
  //   }
  // }, [account]);

  console.log('balanceAlgo', balanceAlgo);
  // useEffect(() => {
  //   if (tokenConvertionRates?.length) {
  //     tokenConvertionRates?.forEach((one: any) => {
  //       switch (one?.currency) {
  //         case 'ALGO': {
  //           const totalAlgoPrice = one?.rate * balanceAlgo;
  //           setAlgoPrice(Number(totalAlgoPrice.toFixed(4)));
  //           break;
  //         }
  //         case 'ZONE': {
  //           const totalZonePrice = one?.rate * balanceZone;
  //           setZonePrice(Number(totalZonePrice.toFixed(4)));
  //           break;
  //         }
  //         case 'USDC': {
  //           const totalUSDCPrice = one?.rate * USDCBalance;
  //           setUSDCPrice(Number(totalUSDCPrice.toFixed(4)));
  //           break;
  //         }
  //         case 'BNB': {
  //           const totalBNBPrice = one?.rate * balanceBNB;
  //           setBNBPrice(Number(totalBNBPrice.toFixed(5)));
  //           break;
  //         }
  //         case 'PEPE': {
  //           const totalPEPEPrice = one?.rate * pepeBalance;
  //           setPEPEPrice(Number(totalPEPEPrice.toFixed(4)));
  //           break;
  //         }
  //         case 'DEFLY': {
  //           const totalDeflyPrice = one?.rate * deflyBalance;
  //           setDeflyPrice(Number(totalDeflyPrice.toFixed(4)));
  //           break;
  //         }
  //         case 'GALGO': {
  //           const totalGAlgoPrice = one?.rate * gAlgoBalance;
  //           setGAlgoPrice(Number(totalGAlgoPrice.toFixed(4)));
  //           break;
  //         }
  //         case 'STKE': {
  //           const totalSTKEPrice = one?.rate * algoStkBalance;
  //           setSTKEPrice(Number(totalSTKEPrice.toFixed(4)));
  //           break;
  //         }
  //         case 'COOP': {
  //           const totalCOOPPrice = one?.rate * CoopBalance;
  //           setCoopPrice(Number(totalCOOPPrice.toFixed(4)));
  //           break;
  //         }
  //         case 'META': {
  //           const totalMETAPrice = one?.rate * MetaBalance;
  //           setCoopPrice(Number(totalMETAPrice.toFixed(4)));
  //           break;
  //         }
  //       }
  //     });
  //   }
  // }, [tokenConvertionRates]);
  const { isMobile } = useDeviceDetect();

  return (
    <div>
      {/* <div className="d-flex align-items-center">
        <div>
          <Link href="/" passHref legacyBehavior>
            <div className="cursor-pointer inline">
              <Image
                src={imageUrls.backArrow}
                alt="back"
                width={22}
                height={16}
              />
            </div>
          </Link>
        </div>
        <Styled.Title className="ml-2">Wallet</Styled.Title>
      </div> */}
      <div
        className={clsx(
          'd-flex align-items-start justify-content-between mt-4 w-100',
          isMobile && 'flex-column-reverse',
        )}
      >
        <Styled.WalletContainer className={clsx(isMobile && 'w-full mt-4')}>
          {isMobile ? (
            <div className="w-100">
              {tab === 0 ? (
                <AddBalance address={account} isMobile={isMobile} />
              ) : tab === 1 ? (
                <div>
                  <SendTransaction
                    address={account}
                    total={total}
                    isMobile={isMobile}
                  />
                </div>
              ) : (
                <TansactionsList address={account} isMobile={isMobile} />
              )}
            </div>
          ) : (
            <Styled.TabsContainer
              id="fill-tab-example"
              activeKey={key}
              // @ts-ignore:next-line
              onSelect={k => setKey(k)}
              variant={'pills'}
              className="mb-3"
            >
              {/* <Tab
                eventKey="addBalance"
                title={
                  <div className={clsx('d-flex align-items-center')}>
                    {' '}
                    <Image
                      src={PROFILE_URLS.AddBalanceIcon}
                      alt="add"
                      width={18}
                      height={18}
                    />
                    <span className="ml-1">Add Balance</span>
                  </div>
                }
              >
                <AddBalance address={account} isMobile={isMobile} />
              </Tab> */}
              <Tab
                eventKey="sendTransaction"
                title={
                  <div className={clsx('d-flex align-items-center')}>
                    {' '}
                    <Image
                      src={PROFILE_URLS.SendBalanceIcon}
                      alt="send"
                      width={18}
                      height={18}
                    />
                    <span className="ml-1">Send</span>
                  </div>
                }
              >
                <SendTransaction
                  address={account}
                  total={total}
                  isMobile={isMobile}
                />
              </Tab>
              <Tab
                eventKey="transactions"
                title={
                  <div className={clsx('d-flex align-items-center')}>
                    {' '}
                    <Image
                      src={PROFILE_URLS.TransactionsIcon}
                      alt="transactions"
                      width={18}
                      height={18}
                    />
                    <span className="ml-1">Transactions</span>
                  </div>
                }
              >
                <TansactionsList address={account} isMobile={isMobile} />
              </Tab>
            </Styled.TabsContainer>
          )}
        </Styled.WalletContainer>
        {isMobile && (
          <div className="d-flex w-100 justify-content-around mt-4">
            {/* <div onClick={() => setTab(0)}>
              <Styled.CustomisedTab>
                <Image
                  src={PROFILE_URLS.AddBalanceIcon}
                  alt="add"
                  width={18}
                  height={18}
                />
              </Styled.CustomisedTab>
              <Styled.CustomisedTabTitle className="mt-1">
                Add Balance
              </Styled.CustomisedTabTitle>
            </div> */}
            <div onClick={() => setTab(1)}>
              <Styled.CustomisedTab>
                <Image
                  src={PROFILE_URLS.SendBalanceIcon}
                  alt="send"
                  width={18}
                  height={18}
                />
              </Styled.CustomisedTab>
              <Styled.CustomisedTabTitle className="mt-1">
                Send
              </Styled.CustomisedTabTitle>
            </div>
            <div onClick={() => setTab(2)}>
              <Styled.CustomisedTab>
                <Image
                  src={PROFILE_URLS.TransactionsIcon}
                  alt="transactions"
                  width={18}
                  height={18}
                />
              </Styled.CustomisedTab>
              <Styled.CustomisedTabTitle className="mt-1">
                Transactions
              </Styled.CustomisedTabTitle>
            </div>
          </div>
        )}

        <Styled.BalanceContainer>
          <Styled.AccordionWrapper
            {...(!isMobile ? { defaultActiveKey: '0' } : {})}
          >
            <Accordion.Item className="bg-transparent" eventKey="0">
              <Styled.AccordionHeader>
                <Styled.TotalAssets>
                  <span className="d-flex align-items-baseline">
                    {blockChain === 'BINANCE'
                      ? BNBPriceInUSD.toFixed(4)
                      : (
                          algoPriceInUSD +
                          zonePriceInUSD +
                          USDCPriceInUSD +
                          PEPEPriceInUSD +
                          DeflyPriceInUSD +
                          STKEPriceInUSD +
                          GAlgoPriceInUSD +
                          CoopPriceInUSD
                        ).toFixed(4)}
                    <h5 className="ml-1">USD</h5>
                  </span>
                  <Styled.TotalAssets className="font400">
                    Total Asset Value
                  </Styled.TotalAssets>
                </Styled.TotalAssets>
              </Styled.AccordionHeader>
              <Accordion.Body>
                <Styled.AccordionBodyWrapper>
                  {blockChain === 'BINANCE' ? (
                    <div>
                      <div className="d-flex align-items-baseline justify-content-between w-100 text-light">
                        <div className="d-flex align-items-center">
                          <Image
                            src={imageUrls?.bnbLogo}
                            alt="prize"
                            width={18}
                            height={18}
                          />
                          <span className="ml-1">BNB</span>
                        </div>
                        <h6 className="text-light">
                          {toCustomFixed(balanceBNB, 5)}
                        </h6>
                      </div>
                      <Styled.Info className="d-flex align-items-center justify-content-between assetBalance">
                        <span>Binance</span>
                        <span>{`≈ $${toCustomFixed(BNBPriceInUSD, 4)}`}</span>
                      </Styled.Info>
                    </div>
                  ) : (
                    <>
                      {balanceAlgo > 0 && (
                        <div>
                          <div className="d-flex align-items-baseline justify-content-between w-100 text-light">
                            <div className="d-flex align-items-center">
                              <Image
                                src={imageUrls?.algoCoin}
                                alt="prize"
                                width={18}
                                height={18}
                              />
                              <span className="ml-1">Algorand</span>
                            </div>
                            <h6 className="text-light">
                              {parseFloat(balanceAlgo.toFixed(4))}
                            </h6>
                          </div>
                          <Styled.Info className="d-flex align-items-center justify-content-between assetBalance">
                            <span>ALGO</span>
                            <span>{`≈ $${algoPriceInUSD}`}</span>
                          </Styled.Info>
                        </div>
                      )}
                      {balanceZone > 0 && (
                        <div className="mt-4">
                          <div className="d-flex align-items-baseline justify-content-between w-100 text-light">
                            <div className="d-flex align-items-center">
                              <Image
                                src={imageUrls?.zoneCoin}
                                alt="prize"
                                width={18}
                                height={18}
                              />
                              <span className="ml-1">ZONE</span>
                            </div>
                            <h6 className="text-light">{balanceZone}</h6>
                          </div>
                          <Styled.Info className="d-flex align-items-center justify-content-between assetBalance">
                            <span>ZONE</span>
                            <span>{`≈ $${zonePriceInUSD}`}</span>
                          </Styled.Info>
                        </div>
                      )}
                      {USDCBalance > 0 && (
                        <div className="mt-4">
                          <div className="d-flex align-items-baseline justify-content-between w-100 text-light">
                            <div className="d-flex align-items-center">
                              <Image
                                src={imageUrls?.usdcCoin}
                                alt="prize"
                                width={18}
                                height={18}
                              />
                              <span className="ml-1">USDC</span>
                            </div>
                            <h6 className="text-light">{USDCBalance}</h6>
                          </div>
                          <Styled.Info className="d-flex align-items-center justify-content-between assetBalance">
                            <span>USDC</span>
                            <span>{`≈ $${USDCPriceInUSD}`}</span>
                          </Styled.Info>
                        </div>
                      )}
                      {pepeBalance > 0 && (
                        <div className="mt-4">
                          <div className="d-flex align-items-baseline justify-content-between w-100 text-light">
                            <div className="d-flex align-items-center">
                              <Image
                                src={HOMEPAGE?.coinPEPE}
                                alt="prize"
                                width={18}
                                height={18}
                              />
                              <span className="ml-1">PEPE</span>
                            </div>
                            <h6 className="text-light">{pepeBalance}</h6>
                          </div>
                          {/* <Styled.Info className="d-flex align-items-center justify-content-between assetBalance">
                          <span>PEPE</span>
                          <span>{`≈ $${PEPEPriceInUSD}`}</span>
                        </Styled.Info> */}
                        </div>
                      )}
                      {deflyBalance > 0 && (
                        <div className="mt-4">
                          <div className="d-flex align-items-baseline justify-content-between w-100 text-light">
                            <div className="d-flex align-items-center">
                              <Image
                                src={HOMEPAGE?.deflyToken}
                                alt="prize"
                                width={18}
                                height={18}
                              />
                              <span className="ml-1">DEFLY</span>
                            </div>
                            <h6 className="text-light">{deflyBalance}</h6>
                          </div>
                          {/* <Styled.Info className="d-flex align-items-center justify-content-between assetBalance">
                          <span>DEFLY</span>
                          <span>{`≈ $${DeflyPriceInUSD}`}</span>
                        </Styled.Info> */}
                        </div>
                      )}
                      {algoStkBalance > 0 && (
                        <div className="mt-4">
                          <div className="d-flex align-items-baseline justify-content-between w-100 text-light">
                            <div className="d-flex align-items-center">
                              <Image
                                src={HOMEPAGE?.AlgoStakeIcon}
                                alt="prize"
                                width={18}
                                height={18}
                              />
                              <span className="ml-1">STKE</span>
                            </div>
                            <h6 className="text-light">{algoStkBalance}</h6>
                          </div>
                          {/* <Styled.Info className="d-flex align-items-center justify-content-between assetBalance">
                          <span>STKE</span>
                          <span>{`≈ $${STKEPriceInUSD}`}</span>
                        </Styled.Info> */}
                        </div>
                      )}
                      {gAlgoBalance > 0 && (
                        <div className="mt-4">
                          <div className="d-flex align-items-baseline justify-content-between w-100 text-light">
                            <div className="d-flex align-items-center">
                              <Image
                                src={HOMEPAGE?.GAlgo}
                                alt="prize"
                                width={18}
                                height={18}
                              />
                              <span className="ml-1">GALGO</span>
                            </div>
                            <h6 className="text-light">{gAlgoBalance}</h6>
                          </div>
                          {/* <Styled.Info className="d-flex align-items-center justify-content-between assetBalance">
                          <span>GALGO</span>
                          <span>{`≈ $${GAlgoPriceInUSD}`}</span>
                        </Styled.Info> */}
                        </div>
                      )}
                      {CoopBalance > 0 && (
                        <div className="mt-4">
                          <div className="d-flex align-items-baseline justify-content-between w-100 text-light">
                            <div className="d-flex align-items-center">
                              <Image
                                src={HOMEPAGE?.CoopCoin}
                                alt="prize"
                                width={18}
                                height={18}
                              />
                              <span className="ml-1">COOP</span>
                            </div>
                            <h6 className="text-light">{CoopBalance}</h6>
                          </div>
                          {/* <Styled.Info className="d-flex align-items-center justify-content-between assetBalance">
                          <span>COOP</span>
                          <span>{`≈ $${CoopBalance}`}</span>
                        </Styled.Info> */}
                        </div>
                      )}
                      {MetaBalance > 0 && (
                        <div className="mt-4">
                          <div className="d-flex align-items-baseline justify-content-between w-100 text-light">
                            <div className="d-flex align-items-center">
                              <Image
                                src={HOMEPAGE?.MetaCoin}
                                alt="prize"
                                width={18}
                                height={18}
                              />
                              <span className="ml-1">META</span>
                            </div>
                            <h6 className="text-light">{MetaBalance}</h6>
                          </div>
                          {/* <Styled.Info className="d-flex align-items-center justify-content-between assetBalance">
                          <span>COOP</span>
                          <span>{`≈ $${MetaBalance}`}</span>
                        </Styled.Info> */}
                        </div>
                      )}
                    </>
                  )}

                  {/* <div className="d-flex align-items-baseline justify-content-between w-100 text-light mt-4">
              <div className="d-flex align-items-center">
                <Image
                  src={homePageImages?.MaticLogo}
                  alt="prize"
                  width={18}
                  height={18}
                />
                <span className="ml-1">Polygon</span>
              </div>
              <h6 className="text-light">{balanceBNB}</h6>
            </div> */}
                </Styled.AccordionBodyWrapper>
              </Accordion.Body>
            </Accordion.Item>
          </Styled.AccordionWrapper>
        </Styled.BalanceContainer>
      </div>
    </div>
  );
};
export default WalletDetails;

const AddBalance = ({
  address,
  isMobile,
}: {
  address: any;
  isMobile: boolean;
}) => {
  const handleCopyAddress = () => {
    address && copyToClipboardText(address);
    toast.success('Copied successfully');
  };

  return (
    <div className="d-flex flex-column align-items-center">
      <Styled.Title>Wallet Address</Styled.Title>
      <Styled.WalletAddressBox className={clsx(isMobile && 'w-250')}>
        {address}
      </Styled.WalletAddressBox>
      <Styled.CopyAddressBtn onClick={handleCopyAddress}>
        <Image src={imageUrls.copyBtn} alt="copy-btn" width={12} height={14} />
        <span className="ml-1">Copy Address</span>
      </Styled.CopyAddressBtn>
      <Styled.Info className="mt-4">
        Please check your wallet address to send selected amount correctly
      </Styled.Info>
    </div>
  );
};
